module.exports = __webpack_public_path__ + "img/light-bulb.fc2fe5ed.png";